import { render, staticRenderFns } from "./VueEmail.vue?vue&type=template&id=7d514809&scoped=true"
import script from "./VueEmail.vue?vue&type=script&lang=js"
export * from "./VueEmail.vue?vue&type=script&lang=js"
import style0 from "./VueEmail.vue?vue&type=style&index=0&id=7d514809&prod&lang=scss&scoped=true"
import style1 from "./VueEmail.vue?vue&type=style&index=1&id=7d514809&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d514809",
  null
  
)

export default component.exports